var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchieveMilestone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6 7.6894 6 7.53407 6.05075 7.41153C6.11841 7.2482 6.24819 7.1184 6.41155 7.05073C6.53406 7 6.6894 7 7 7H9C9.3106 7 9.46593 7 9.58847 7.05073C9.7518 7.1184 9.8816 7.2482 9.94927 7.41153C10 7.53407 10 7.6894 10 8C10 8.3106 10 8.46593 9.94927 8.58847C9.8816 8.7518 9.7518 8.8816 9.58847 8.94927C9.46593 9 9.3106 9 9 9H7C6.6894 9 6.53406 9 6.41155 8.94927C6.24819 8.8816 6.11841 8.7518 6.05075 8.58847C6 8.46593 6 8.3106 6 8Z",
    stroke: "#292D32",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6673 4.66602V8.66602C13.6673 11.1801 13.6673 12.4373 12.8862 13.2183C12.1052 13.9993 10.8481 13.9993 8.33398 13.9993H7.66732C5.15316 13.9993 3.89608 13.9993 3.11503 13.2183C2.33398 12.4373 2.33398 11.1801 2.33398 8.66602V4.66602",
    stroke: "#292D32",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 3.33333C1.33398 2.70479 1.33398 2.39053 1.52924 2.19526C1.72451 2 2.03878 2 2.66732 2H13.334C13.9625 2 14.2768 2 14.4721 2.19526C14.6673 2.39053 14.6673 2.70479 14.6673 3.33333C14.6673 3.96187 14.6673 4.27614 14.4721 4.47141C14.2768 4.66667 13.9625 4.66667 13.334 4.66667H2.66732C2.03878 4.66667 1.72451 4.66667 1.52924 4.47141C1.33398 4.27614 1.33398 3.96187 1.33398 3.33333Z",
    stroke: "#292D32",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchieveMilestone);
export default __webpack_public_path__ + "static/media/archieve-milestone.1be8e4b3f1a61234c53cf9ddba4096d8.svg";
export { ForwardRef as ReactComponent };